import React from 'react';
import config from '../../config';
import { isWebKit } from '@helpers/hooks';
import ConditionalLink from '../components/ConditionalLink/ConditionalLink.jsx';
import { getConditionalLinkType } from './conditionalLink';

export function link(element, href = '/', NextLink) {
  if (getConditionalLinkType(href))
    return <ConditionalLink href={href}>{element}</ConditionalLink>;

  if (NextLink)
    return (
      <NextLink prefetch={false} href={href}>
        {element}
      </NextLink>
    );

  return (
    <a
      {...(isExternalLink(href) && {
        target: '_blank',
        rel: 'noopener noreferrer'
      })}
      href={href}
    >
      {element}
    </a>
  );
}

export function isExternalLink(link) {
  return link && !link.startsWith('/') && !link.includes(config.domain);
}

export function withNavigationDelay(fn, options = {}) {
  const { webkitDelay = 1250, defaultDelay = 750 } = options;

  const delay = isWebKit() ? webkitDelay : defaultDelay;

  setTimeout(fn, delay);
}
